// libs
import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Stack, Tooltip } from '@lyearn/ui';
import { AssignmentTypeEnum, EventUnion } from '@/types/schema';

import { contentStyles } from '../CollectionItemViewer/style';
import SessionItem from './SessionItem';

function SessionItemViewer({
  event,
  onDelete,
  disabled,
  assignmentType,
  Actions,
}: {
  event: EventUnion;
  onDelete?: (eventId: string) => void;
  disabled?: boolean;
  assignmentType?: AssignmentTypeEnum;
  Actions?: JSX.Element;
}) {
  const { t } = useTranslation('Events');
  const _onDelete = useCallback(() => onDelete?.(event.id), [onDelete, event.id]);

  return (
    <Stack
      className={cn(contentStyles, 'rounded-8 px-4', {
        'group hover:bg-s-info-light': !disabled,
      })}>
      <Stack
        alignItems="center"
        className="content w-full border-b border-solid border-interactive-border py-16 px-12"
        gapX={4}
        justifyContent="between">
        <SessionItem assignmentType={assignmentType} event={event} />
        {Actions || (
          <Tooltip placement="right" title={`${t('Events:RemoveSession')}`}>
            <LinkButton
              className="flex-shrink-0 py-2 px-4 opacity-0 transition duration-150 ease-linear group-hover:opacity-100"
              color={'internal'}
              disabled={disabled}
              onClick={_onDelete}>
              <Close />
            </LinkButton>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}

export default SessionItemViewer;
